// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__oP1xJ","name":"ConsentHeader_name__2qU-d","birthday":"ConsentHeader_birthday__3ftXc","skeleton":"ConsentHeader_skeleton__16Odv"};